import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

import publicConfig from "@/config/public";
import logError from "@/utils/logError";

const { googleMapsApiKey } = publicConfig;

export default async () => {
  // Because google maps is picky, any libraries that need to be loaded at
  // any point need to be loaded no matter what when google maps is first
  // loaded in.
  setOptions({
    key: googleMapsApiKey,
  });

  try {
    importLibrary("geometry");
    importLibrary("places");
  } catch {
    logError("Could not intitialize google maps");
  }
};
